const getters = {
    profileIds: (state, getters) => state.profileIds,
    selectedSoundSource: (state) => state.soundSource,
    accountTimeRange: (state) => state.widgets['account'].timeRange,
    myprofilesTimeRange: (state) => state.widgets['myprofiles'].timeRange,
    editDeleteAccountTimeRange: (state) => state.widgets['editDeleteAccount'].timeRange,
    profilesTimeRange: (state) => state.widgets['profiles'].timeRange,
    supportTimeRange: (state) => state.widgets['support'].timeRange,
    doseChartsTimeRange: (state) => state.widgets['doseCharts'].timeRange,
    mapTimeRange: (state) => state.widgets['map'].timeRange,
    histogramTimeRange: (state) => state.widgets['histogram'].timeRange,
    dbDoughnutTimeRange: (state) => state.widgets['dbDoughnut'].timeRange,
    progressTimeRange: (state) => state.widgets['progress'].timeRange,
    // from other modules
    availableProfileIds: (state, getters, rootState, rootGetters) => rootGetters['auth/profileIds'],
};
export default getters;
